<template>
  <table class="table table-borderless">
    <tbody>

    <tr class="d-flex">
      <th class="col-4">
        <span v-b-tooltip title="Eigen omschrijving van de rit, wordt niet gebruikt in de berekening">
          Omschrijving
        </span>
      </th>
      <th class="col-2 mb-n3">
        <div v-b-tooltip
            title="Hoe lang de auto rijdt, berekend als het aantal minuten dat de auto met de app geopend is tijdens de rit">
          <div>
            Rijden
          </div>
          <div class="row">
            <div class="col-6 pr-0"><small class="text-muted">uren</small></div>
            <div class="col-6 pl-0"><small class="text-muted">minuten</small></div>
          </div>
        </div>
      </th>
      <th class="col-2 mb-n3">
        <div v-b-tooltip
            title="Hoe lang de auto stilstaat, berekend als het aantal minuten dat de auto met de app gesloten is tijdens de rit">
          <div>Stilstaan</div>
          <div class="row">
            <div class="col-6 pr-0"><small class="text-muted">uren</small></div>
            <div class="col-6 pl-0"><small class="text-muted">minuten</small></div>
          </div>
        </div>
      </th>
      <th class="col-1" id="test">
        <span v-b-tooltip title="Aantal keer dat de rit gemaakt wordt" container="test">
          Aantal
        </span>
      </th>
      <th class="col-2 text-right">
        <span v-b-tooltip title="Berekend tarief">
          Tarief
        </span>
      </th>
      <th class="col-1"></th>
    </tr>

    <tr class="d-flex" v-for="(row, index) in rows" v-bind:key="index">
      <td class="col-4">
        <b-form-input v-model="row.description" ref="description"/>
      </td>
      <td class="col-2">
        <b-input-group>
          <b-form-input v-model="row.drive_hours" class="col-6 text-right"/>
          <b-form-input v-model="row.drive_mins" class="col-6 text-right"/>
        </b-input-group>
      </td>
      <td class="col-2">
        <b-input-group>
          <b-form-input v-model="row.park_hours" class="col-6 text-right"/>
          <b-form-input v-model="row.park_mins" class="col-6 text-right"/>
        </b-input-group>
      </td>
      <td class="col-1">
        <b-form-input v-model="row.amount" class="text-right"/>
      </td>
      <td class="col-2">
        <b-form-input :value="renderEuros(amount(row))" plaintext class="text-right" tabindex="-1"/>
      </td>
      <td class="col-1">
        <b-button variant="danger" v-on:click="deleteRow(index)" v-if="index < rows.length - 1">
          <fas-icon fixed-width icon="trash-alt"/>
        </b-button>
      </td>
    </tr>

    <tr class="d-flex">
      <th class="col-4">Totaal</th>
      <th class="col-5" colspan="3"></th>
      <th class="col-2">
        <b-form-input plaintext class="text-right font-weight-bold" tabindex="-1" :value="renderEuros(totalAmount)"/>
      </th>
      <th class="col-1">
        <b-button variant="primary" v-on:click="copyUrl()" v-b-tooltip
            title="Kopieer URL naar het klembord om de berekening te delen" v-if="totalAmount > 0">
          <fas-icon fixed-width icon="copy"/>
        </b-button>
        <b-toast id="copy-url-toast" no-close-button auto-hide-delay="2000">
          URL gekopieerd naar klembord.
        </b-toast>
      </th>
    </tr>

    <tr class="d-flex">
      <td class="col-9"></td>
      <td class="col-3 text-right">
        <div v-if="totalAmount > 0">
          <b-button variant="primary" href="https://www.anwb.nl/auto/autokosten" target="_blank" v-b-tooltip
              title="Maak een vergelijking met de kosten van je huidige auto op anwb.nl">
            <fas-icon icon="balance-scale-left"/>
            Vergelijk op ANWB
          </b-button>
        </div>
      </td>
    </tr>

    </tbody>
  </table>
</template>

<script>
import {isEqual, last, nth} from "lodash"
import * as log from 'loglevel';

function shuffleArray(array) {
  const a = array.slice()
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]]
  }
  return a
}

const RATES = {
  drive: 19,
  park: 4,
}

const DESCRIPTION_PLACEHOLDERS = shuffleArray([
  'boodschappen',
  'naar oma',
  'weekendje weg',
  'voetbal',
  'naar werk',
  'bingoavond',
  'met de jongens naar Vlieland',
  'naar het strand',
  'middag met de meiden',
  'uit eten',
  'bibliotheek',
  'dagje Antwerpen',
  'naar de stad',
  'kinderen ophalen',
])

export default {
  name: 'BundelCalculator',

  data() {
    return {
      rows: [],
    }
  },

  computed: {
    totalAmount() {
      return this.rows.map(this.amount).reduce((a, b) => a + b, 0)
    },
  },

  mounted() {
    this.$refs['description'][this.rows.length - 1].focus();
  },

  methods: {
    newRow() {
      return {
        description: '',
        drive_hours: '',
        drive_mins: '',
        park_hours: '',
        park_mins: '',
        amount: '1',
      }
    },

    rowIsChanged(row) {
      return !isEqual(row, this.newRow());
    },

    ensureEmptyRow() {
      // Ensure empty row at the bottom
      if (this.rows.length === 0 || this.rowIsChanged(last(this.rows))) {
        this.rows.push(this.newRow())
      }

      // Ensure at most one empty row at the bottom
      while (this.rows.length > 1 && !this.rowIsChanged(nth(this.rows, -2))) {
        this.rows.splice(-1, 1)
      }
    },

    deleteRow(index) {
      this.rows.splice(index, 1)
    },

    amount(row) {
      const drive_mins = (parseInt(row.drive_hours) || 0) * 60 + (parseInt(row.drive_mins) || 0)
      const park_mins = (parseInt(row.park_hours) || 0) * 60 + (parseInt(row.park_mins) || 0)
      return row.amount * (drive_mins * RATES.drive + park_mins * RATES.park) / 100
    },

    descriptionPlaceholder(index) {
      index = index % DESCRIPTION_PLACEHOLDERS.length;
      return 'bijv. ' + DESCRIPTION_PLACEHOLDERS[index]
    },

    renderEuros(amount) {
      if (isNaN(amount)) {
        return '?'
      }
      return '€ ' + amount.toFixed(2).toString().replace('.', ',')
    },

    copyUrl() {
      this.$ga.event('BundleCalculator', 'copy', null, this.totalAmount)
      this.$copyText(window.location)
      this.$bvToast.show('copy-url-toast')
    },
  },

  watch: {
    '$route': {
      handler(route) {
        if (!route.hash) return;

        try {
          const state = route.hash.substr(1)
          const json = Buffer.from(state, 'base64').toString()
          const newRows = JSON.parse(json)
          if (!isEqual(newRows, this.rows)) this.rows = newRows
        } catch (e) {
          log.warn(`URL fragment did not contain valid state: ${route.hash}`)
        }
      },
      immediate: true,
    },
    'rows': {
      handler(rows) {
        this.ensureEmptyRow()

        const json = JSON.stringify(rows.slice(0, -1))
        const state = Buffer.from(json).toString('base64')
        const path = this.$router.currentRoute.path
        this.$router.replace(`${path}#${state}`)
      },
      deep: true,
      immediate: true,
    },
  },
}
</script>
